import React, { useState } from "react";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { Button, message } from "antd";
import { useSupplierModel } from "../supplierModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";

export const DataBox = () => {
    const { setSynchroModel, selectedRowKeys, setDrawerVisible, syncData } = useSupplierModel();
    const [syncLoading, setSyncLoading] = useState<boolean>(false);
    const onOpenDrawer = () => {
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            setDrawerVisible(true);
        } else {
            message.error("请选择供应商!");
        }
    }

    const action = (
        <>
            <YhAuth resCode={ResourceAuthEnum.DATA_S_VW}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={onOpenDrawer}
                >查看</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.DATA_S_SYNC}>
                {/* <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={() => {
                        setSynchroModel(true)
                    }}
                >同步</Button> */}
                {/* <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    loading={syncLoading}
                    onClick={() => {
                        setSyncLoading(true);
                        syncData().then(res => setSyncLoading(false)).catch(err => setSyncLoading(false));
                    }}
                >{syncLoading ? "同步中" : "同步"}</Button> */}
            </YhAuth>
        </>
    );

    return (
        <YhBox title=" " action={action}>
            <DataTable />
        </YhBox>
    )
}